export default __webpack_public_path__ + "static/panorama_code-e5d9eb3ad359e41ad353fff76106fca1.png";